import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import cx from 'classnames';

import { Link } from '@nord/ui';

import TextWithIcon from '../../molecules/TextWithIcon';

export interface IBackButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  pathname?: string;
  buttonText?: React.ReactNode;
  wrapperClassName?: string;
  colorClassName?: string;
}

const BackButton: FC<IBackButtonProps> = ({
  pathname,
  buttonText = 'Go back',
  className,
  ...rest
}) => {
  const history = useHistory();
  const handleClick = useCallback(() => {
    if (pathname) {
      history.push(pathname);
    } else {
      history.goBack();
    }
  }, [pathname, history]);

  return (
    <Link
      data-testid="back-button"
      className={cx('font-medium inline-block', className)}
      colorClassName="text-blue"
      onClick={handleClick}
      {...rest}
    >
      <TextWithIcon icon="images/global/icons/16/chevrons-left.svg" title="Back" variant="caption">
        {buttonText}
      </TextWithIcon>
    </Link>
  );
};

export default BackButton;
